import { AI_API_SNIPPET_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  DeferedResultsParams,
  Error,
  GetRubyFileOrSuiteResponse
} from '@eggplant/types'
import type {
  ReactElement,
  ReactNode
} from 'react'

interface Props {
  params?: DeferedResultsParams
  onSuccess?: (data: GetRubyFileOrSuiteResponse) => void
  children?: (data: any) => ReactElement | ReactNode
  onError?: (error: Error) => void
}

const SaveRubyDeferedResults = ({
  params,
  onSuccess,
  children,
  onError
}: Props) => {
  const url = `${AI_API_SNIPPET_SERVICE}/getDeferedResults`

  return (
    <AuthenticatedDataRequest
      children={children}
      isUrlEncoded
      method='post'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default SaveRubyDeferedResults
